import React from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header";
import { Trans } from "react-i18next";

const URI_VENTA_EN_LINEA = process.env.REACT_APP_URI_VENTA_EN_LINEA;

const NotFound = () => {
  return (
    <main className="overlay container">
      <Header />
      <section className="container-fluid container-padding text-center short">
        <h1>
          <Trans>venta_linea.not_found.title</Trans>
        </h1>
        <p>
          <Trans>venta_linea.not_found.subtitle</Trans>
        </p>
        <p>
          <Trans>venta_linea.not_found.description</Trans>
        </p>
        <Link
          to={URI_VENTA_EN_LINEA}
          className="btn btn-primary btn-full-width"
        >
          <Trans>venta_linea.not_found.btn_cta</Trans>
        </Link>
      </section>
    </main>
  );
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/store/404/index.jsx